/* ===========================================================================
   lyouna-plp.js — LYOUNA collection page: filters, sort, wishlist, sheet
   ---------------------------------------------------------------------------
   Ported from Assets/handoff/lyouna/reference/lyouna-plp.js, with the demo
   data taken out. Three changes that matter:

   1. The reference hardcodes 11 product types, 6 sizes and an 11-colour swatch
      map. Here every option is DERIVED server-side from the collection's real
      products (sections/lyouna-collection.liquid) and this file only reads the
      DOM. LYOUNA's live catalogue has sizes like "M/B" and "xxxl", which no
      hardcoded XS–XXL list would have matched.
   2. Cards carry MULTIPLE colours and sizes (a real product has variants), so
      the card datasets are pipe-separated lists rather than the reference's
      single data-color / space-separated data-sizes.
   3. Wishlist writes to 'at_wishlist' — the key the rest of the theme already
      uses (omes-brand-collection, omes-product.js, legacy-collection) — so the
      header counter and /pages/wishlist stay in step.

   Filter logic is unchanged from the spec: OR within a group, AND across
   groups. Options absent from the current category are removed; options
   present but with zero matches under the other active filters go to 40%.
   =========================================================================== */
(function () {
  "use strict";

  var WL_KEY = "at_wishlist";

  function init(root) {
    if (!root || root.dataset.lyInit === "1") return;
    root.dataset.lyInit = "1";

    var grid = root.querySelector("[data-ly-grid]");
    var empty = root.querySelector("[data-ly-empty]");
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(".ly-card"));
    cards.forEach(function (c, i) { c.dataset.i = i; });

    var catsWrap = root.querySelector("[data-ly-cats]");
    var typeWrap = root.querySelector("[data-ly-f-type]");
    var sizeWrap = root.querySelector("[data-ly-f-size]");
    var colorWrap = root.querySelector("[data-ly-f-color]");
    var priceInput = root.querySelector("[data-ly-f-price]");
    var priceOut = root.querySelector("[data-ly-price-out]");
    var pills = root.querySelector("[data-ly-pills]");
    var sortSel = root.querySelector("[data-ly-sort]");
    var sheet = root.querySelector("[data-ly-sheet]");
    var scrim = root.querySelector("[data-ly-scrim]");
    var applyBtn = root.querySelector("[data-ly-apply]");
    var countBadge = root.querySelector("[data-ly-fcount]");

    var PRICE_MAX = priceInput ? +priceInput.max : 0;
    var CURRENCY = root.dataset.lyCurrency || "DT";

    var st = { cat: "all", types: [], sizes: [], colors: [], max: PRICE_MAX, sort: "new" };

    function list(el, key) {
      var v = (el.dataset[key] || "").trim();
      return v ? v.split("|") : [];
    }

    function inCat(c) {
      return st.cat === "all" || list(c, "cat").indexOf(st.cat) >= 0;
    }

    /* `skip` lets a group's own options be counted as if that group were not
       filtering — otherwise selecting one type would grey out every other. */
    function match(c, skip) {
      if (!inCat(c)) return false;
      if (skip !== "types" && st.types.length && st.types.indexOf(c.dataset.type) < 0) return false;
      if (skip !== "sizes" && st.sizes.length) {
        var s = list(c, "sizes");
        if (!st.sizes.some(function (x) { return s.indexOf(x) >= 0; })) return false;
      }
      if (skip !== "colors" && st.colors.length) {
        var k = list(c, "colors");
        if (!st.colors.some(function (x) { return k.indexOf(x) >= 0; })) return false;
      }
      if (st.max && +c.dataset.price > st.max) return false;
      return true;
    }

    /* Show/hide and grey the options of one group. `values(card)` returns the
       card's values for that group. */
    function syncGroup(wrap, sel, group, values) {
      if (!wrap) return;
      var catCards = cards.filter(inCat);
      var avail = cards.filter(function (c) { return match(c, group); });
      var nodes = wrap.querySelectorAll(sel);

      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var v = node.dataset.v;
        var inCategory = catCards.some(function (c) { return values(c).indexOf(v) >= 0; });
        var hasMatch = avail.some(function (c) { return values(c).indexOf(v) >= 0; });

        // absent from this category → removed entirely
        node.hidden = !inCategory;
        var label = node.closest("label") || node;
        if (label !== node) label.hidden = !inCategory;

        // present but nothing matches the other filters → 40%
        var target = node.tagName === "INPUT" ? (node.closest("label") || node) : node;
        target.classList.toggle("is-dis", inCategory && !hasMatch);

        // a selection that just left the category drops out of state
        if (!inCategory) {
          var arr = st[group];
          var at = arr.indexOf(v);
          if (at >= 0) {
            arr.splice(at, 1);
            if (node.tagName === "INPUT") node.checked = false;
          }
        }
      }
    }

    function hideEmptyGroups() {
      var groups = root.querySelectorAll("[data-ly-fg]");
      for (var i = 0; i < groups.length; i++) {
        var opts = groups[i].querySelectorAll("[data-v]");
        var any = false;
        for (var j = 0; j < opts.length; j++) {
          var o = opts[j];
          var l = o.closest("label") || o;
          if (!o.hidden && !l.hidden) { any = true; break; }
        }
        groups[i].hidden = opts.length > 0 && !any;
      }
    }

    function render() {
      syncGroup(typeWrap, "input[data-v]", "types", function (c) { return [c.dataset.type]; });
      syncGroup(sizeWrap, ".ly-sz[data-v]", "sizes", function (c) { return list(c, "sizes"); });
      syncGroup(colorWrap, ".ly-sw[data-v]", "colors", function (c) { return list(c, "colors"); });
      hideEmptyGroups();

      // reflect selections that survived
      if (sizeWrap) {
        sizeWrap.querySelectorAll(".ly-sz[data-v]").forEach(function (b) {
          b.classList.toggle("on", st.sizes.indexOf(b.dataset.v) >= 0);
        });
      }
      if (colorWrap) {
        colorWrap.querySelectorAll(".ly-sw[data-v]").forEach(function (b) {
          var on = st.colors.indexOf(b.dataset.v) >= 0;
          b.classList.toggle("on", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
      }

      var vis = cards.filter(function (c) { return match(c); });
      var ord = vis.slice();
      if (st.sort === "asc") ord.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (st.sort === "desc") ord.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else ord.sort(function (a, b) { return a.dataset.i - b.dataset.i; });

      cards.forEach(function (c) { c.hidden = true; });
      ord.forEach(function (c) { c.hidden = false; if (empty) grid.insertBefore(c, empty); });
      if (empty) empty.hidden = vis.length > 0;

      applyLayout(ord);

      if (applyBtn) applyBtn.textContent = vis.length ? "Voir les pièces" : "Aucune pièce";
      if (priceOut) priceOut.textContent = "Jusqu'à " + st.max + " " + CURRENCY;

      if (catsWrap) {
        catsWrap.querySelectorAll(".ly-cat").forEach(function (b) {
          b.classList.toggle("on", b.dataset.cat === st.cat);
        });
      }

      // active filter pills
      var p = [];
      st.types.forEach(function (t) { p.push(["types", t, t]); });
      st.sizes.forEach(function (t) { p.push(["sizes", t, "Taille " + t]); });
      st.colors.forEach(function (t) { p.push(["colors", t, t]); });
      if (st.max && st.max < PRICE_MAX) p.push(["max", "", "≤ " + st.max + " " + CURRENCY]);

      if (pills) {
        pills.innerHTML =
          p.map(function (x) {
            return '<button type="button" class="ly-fpill" data-k="' + x[0] + '" data-v="' +
              String(x[1]).replace(/"/g, "&quot;") + '">' + x[2] +
              '<span aria-hidden="true">×</span></button>';
          }).join("") +
          (p.length > 1 ? '<button type="button" class="ly-fpill ly-fpill--clear" data-k="all">Tout effacer</button>' : "");
      }
      if (countBadge) {
        countBadge.textContent = p.length;
        countBadge.classList.toggle("has", p.length > 0);
      }
    }

    /* ---------------------------------------------------------------------
       Grid layout.

       The handoff's grid is a mosaic: `grid-auto-flow: dense` with featured
       cards spanning 2×2. It hands that role to three named products, which is
       no use here — the catalogue decides what exists, and filtering changes
       what is on screen from one click to the next.

       So the spans are assigned over the VISIBLE, already-sorted list rather
       than baked into the markup. Filter down to two products and the rhythm
       re-forms around them instead of leaving a hole where a hidden card used
       to be. A card tagged as featured always keeps the big tile: explicit
       curation beats the automatic rhythm.
       --------------------------------------------------------------------- */
    var XL_EVERY = 9;      // one 2×2 tile per block of 9
    var WIDE_EVERY = 9;    // editorial only
    var WIDE_OFFSET = 4;

    function applyLayout(ordered) {
      // read per render, not once: the theme editor swaps the attribute in
      // place when the merchant changes the setting
      var LAYOUT = (grid.dataset.lyLayout || "mosaic").toLowerCase();
      for (var i = 0; i < ordered.length; i++) {
        var c = ordered[i];
        var xl = false, wide = false;

        if (LAYOUT !== "uniform") {
          if (c.dataset.featured === "1") xl = true;
          else if (i % XL_EVERY === 0) xl = true;
          else if (LAYOUT === "editorial" && i % WIDE_EVERY === WIDE_OFFSET) wide = true;
        }

        // A span wider than the grid leaves a dead column, so the last row
        // only gets a big tile when there is room for it.
        if ((xl || wide) && ordered.length - i < 2) { xl = false; wide = false; }

        c.classList.toggle("ly-card--xl", xl);
        c.classList.toggle("ly-card--wide", wide);
      }
    }

    function toggle(arr, v) {
      var i = arr.indexOf(v);
      if (i < 0) arr.push(v); else arr.splice(i, 1);
    }

    function reset() {
      st.types = []; st.sizes = []; st.colors = []; st.max = PRICE_MAX;
      if (typeWrap) typeWrap.querySelectorAll("input[data-v]").forEach(function (i) { i.checked = false; });
      if (priceInput) priceInput.value = PRICE_MAX;
      render();
    }

    /* --- events --- */
    if (catsWrap) {
      catsWrap.addEventListener("click", function (e) {
        var b = e.target.closest(".ly-cat");
        if (!b) return;
        st.cat = b.dataset.cat;
        try {
          history.replaceState(null, "", st.cat === "all" ? location.pathname + location.search : "#" + st.cat);
        } catch (err) { /* replaceState can throw in sandboxed previews */ }
        render();
      });
    }
    if (typeWrap) {
      typeWrap.addEventListener("change", function (e) {
        if (!e.target.dataset.v) return;
        toggle(st.types, e.target.dataset.v);
        render();
      });
    }
    if (sizeWrap) {
      sizeWrap.addEventListener("click", function (e) {
        var b = e.target.closest(".ly-sz[data-v]");
        if (!b) return;
        toggle(st.sizes, b.dataset.v);
        render();
      });
    }
    if (colorWrap) {
      colorWrap.addEventListener("click", function (e) {
        var b = e.target.closest(".ly-sw[data-v]");
        if (!b) return;
        toggle(st.colors, b.dataset.v);
        render();
      });
    }
    if (priceInput) {
      priceInput.addEventListener("input", function (e) { st.max = +e.target.value; render(); });
    }
    if (sortSel) {
      sortSel.addEventListener("change", function (e) { st.sort = e.target.value; render(); });
    }
    if (pills) {
      pills.addEventListener("click", function (e) {
        var b = e.target.closest(".ly-fpill");
        if (!b) return;
        var k = b.dataset.k, v = b.dataset.v;
        if (k === "all") return reset();
        if (k === "max") {
          st.max = PRICE_MAX;
          if (priceInput) priceInput.value = PRICE_MAX;
        } else {
          toggle(st[k], v);
          if (k === "types" && typeWrap) {
            var box = typeWrap.querySelector('input[data-v="' + v.replace(/"/g, '\\"') + '"]');
            if (box) box.checked = st.types.indexOf(v) >= 0;
          }
        }
        render();
      });
    }
    root.querySelectorAll("[data-ly-reset]").forEach(function (b) { b.onclick = reset; });

    /* --- mobile filter sheet --- */
    function openSheet(on) {
      if (sheet) sheet.classList.toggle("open", on);
      if (scrim) scrim.classList.toggle("open", on);
      document.body.style.overflow = on ? "hidden" : "";
    }
    root.querySelectorAll("[data-ly-open]").forEach(function (b) { b.onclick = function () { openSheet(true); }; });
    root.querySelectorAll("[data-ly-close]").forEach(function (b) { b.onclick = function () { openSheet(false); }; });
    if (applyBtn) applyBtn.addEventListener("click", function () { openSheet(false); });
    if (scrim) scrim.onclick = function () { openSheet(false); };
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sheet && sheet.classList.contains("open")) openSheet(false);
    });

    /* --- wishlist (shared 'at_wishlist' store) --- */
    function wlGet() {
      try { return JSON.parse(localStorage.getItem(WL_KEY) || "[]"); } catch (e) { return []; }
    }
    function syncWish() {
      var ids = wlGet();
      root.querySelectorAll(".ly-card__wish").forEach(function (b) {
        var on = ids.indexOf((b.dataset.id || "").toString()) > -1;
        b.classList.toggle("is-wished", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    function wlSyncHeader(ids) {
      if (window.checkWishlist) { try { window.checkWishlist(); return; } catch (e) { /* fall through */ } }
      var c = document.querySelector("#wishlistItems");
      if (c) c.innerHTML = ids.length;
    }
    root.addEventListener("click", function (e) {
      var btn = e.target.closest(".ly-card__wish");
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var id = (btn.dataset.id || "").toString();
      var ids = wlGet();
      var i = ids.indexOf(id);
      if (i > -1) ids.splice(i, 1); else ids.unshift(id);
      try { localStorage.setItem(WL_KEY, JSON.stringify(ids)); } catch (err) { /* private mode */ }
      syncWish();
      wlSyncHeader(ids);
    });
    syncWish();

    /* Quick add is [data-quickview] — sections/omes-quick-view.liquid opens the
       modal from a document-level listener. Stop the card's own navigation. */
    grid.addEventListener("click", function (e) {
      if (e.target.closest("[data-quickview]")) e.stopPropagation();
    });

    /* deep link: #maillots etc. preselects the category */
    var h = (location.hash || "").slice(1);
    if (h && catsWrap && catsWrap.querySelector('.ly-cat[data-cat="' + h.replace(/"/g, "") + '"]')) st.cat = h;

    render();
  }

  function boot() {
    document.querySelectorAll("[data-ly-plp]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // Theme editor re-renders a section without a page load.
  document.addEventListener("shopify:section:load", boot);
})();
